/**
 * Switch Component - Toggle switch with labels
 */

import React from 'react';

const Switch = ({
  checked = false,
  onChange,
  label,
  description,
  disabled = false,
  className = '',
  size = 'md',
  ...props
}) => {
  const sizes = {
    sm: 'w-8 h-5',
    md: 'w-11 h-6',
    lg: 'w-14 h-8',
  };

  const dotSizes = {
    sm: 'w-3.5 h-3.5',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  const dotOffsets = {
    sm: 'translate-x-0.5',
    md: 'translate-x-0.5',
    lg: 'translate-x-0.5',
  };

  const dotOnOffsets = {
    sm: 'translate-x-3.5',
    md: 'translate-x-5',
    lg: 'translate-x-6',
  };

  const handleToggle = () => {
    if (!disabled) {
      onChange?.(!checked);
    }
  };

  return (
    <div className={className}>
      <div className="flex items-center gap-3">
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          aria-disabled={disabled}
          className={`
            relative inline-flex shrink-0
            ${sizes[size] || sizes.md}
            rounded-full
            transition-colors duration-200
            ${checked ? 'bg-brand' : 'bg-neutral-300'}
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-brand-hover'}
            focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2
          `}
          onClick={handleToggle}
          {...props}
        >
          <span
            className={`
              absolute top-0.5
              ${dotSizes[size] || dotSizes.md}
              rounded-full bg-white
              shadow-sm
              transition-transform duration-200
              ${checked 
                ? (dotOnOffsets[size] || dotOnOffsets.md)
                : (dotOffsets[size] || dotOffsets.md)
              }
            `}
          />
        </button>

        {(label || description) && (
          <div>
            {label && (
              <span className="text-sm font-medium text-ink">{label}</span>
            )}
            {description && (
              <p className="text-xs text-muted">{description}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

Switch.displayName = 'Switch';

export default Switch;